export default {
  BASE_URL: 'search/order/',
  api: [
    {
      name: 'getStatus',
      method: 'GET',
      desc: '获取订单状态',
      path: 'billStatus'
    },
    {
      name: 'list',
      method: 'GET',
      desc: '订单列表',
      path: 'list'
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '查看详情',
      path: 'detail'
    },
    {
      name: 'signDel',
      method: 'GET',
      desc: '查看送货单',
      path: 'signDel'
    },
    {
      name: 'log',
      method: 'GET',
      desc: '送货单签收明细日志',
      path: 'signDel/log'
    },
    {
      name: 'export',
      method: 'GET',
      desc: '导出订单列表',
      path: 'list/export'
    },
    {
      name: 'supplier',
      method: 'GET',
      desc: '卖家企业模糊查询',
      path: 'supplier'
    },
    {
      name: 'pur',
      method: 'GET',
      desc: '买家企业模糊查询',
      path: 'pur'
    },
    {
      name: 'store',
      method: 'GET',
      desc: '店铺模糊查询',
      path: 'store'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/sa/merchant.js